module.exports = __webpack_public_path__ + "static/media/stb-how-does-it-work.b8c3883b.png";